import type { AxiosError } from 'axios';
import axios from 'axios';
import type { SWRConfiguration } from 'swr';

import notificationService from '../services/notification/notification.service';
import { requestErrorMap } from './constants/errors';
import { formatErrorMessage } from './helpers/formatErrorMessage';

const fetcher =
  <T, B = unknown>(method: 'get' | 'post') =>
  (url: string, body?: B) =>
    axios[method]<T>(url, body).then((res) => res.data);

export const getFetcher = <T>(url: string) => fetcher<T>('get')(url);
export const postFetcher = <T, B>(url: string, { arg }: { arg: B }) => fetcher<T>('post')(url, arg);

export const swrConfig: SWRConfiguration = {
  onError(error: AxiosError<any>) {
    const errorCode: string = error.response?.data?.code || '';
    const formattedError = requestErrorMap.find(({ code }) => code === errorCode);

    notificationService.addNotification({
      heading: formattedError?.heading || 'Error handling request',
      message: formattedError?.message || formatErrorMessage(error),
      variant: 'danger',
    });
  },
  errorRetryCount: 1,
};
